import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon2D = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2.94141,
			y: 2.94141,
			width: 17.6471,
			height: 17.6471,
			rx: 1.83824,
			stroke: "currentColor",
			strokeWidth: 1.25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.377 7.38965C15.1646 7.38971 15.8436 7.55217 16.4102 7.88086H16.4092C16.9756 8.20683 17.4099 8.67607 17.7109 9.28613L17.8164 9.51855C18.0467 10.0756 18.1611 10.7223 18.1611 11.4561C18.1611 12.2994 18.0104 13.0296 17.707 13.6445V13.6455C17.4032 14.2584 16.9598 14.7315 16.3779 15.0625C15.7956 15.3911 15.0904 15.5527 14.2666 15.5527H11.7197V7.38965H14.377ZM12.8369 14.5449H14.2041C14.8578 14.5449 15.3939 14.4192 15.8154 14.1719C16.2377 13.924 16.5519 13.5711 16.7598 13.1123C16.9684 12.6517 17.0742 12.1004 17.0742 11.4561C17.0742 10.8167 16.9698 10.2699 16.7637 9.81445C16.5837 9.41459 16.3271 9.09762 15.9932 8.8623L15.8457 8.7666C15.4398 8.52204 14.9301 8.39746 14.3135 8.39746H12.8369V14.5449Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .147059
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.23926 7.28027C8.71961 7.28027 9.14848 7.3819 9.52344 7.58691C9.89684 7.79109 10.1911 8.06696 10.4043 8.41504C10.6179 8.76376 10.7246 9.15191 10.7246 9.57715C10.7246 9.80495 10.6937 10.029 10.6318 10.249L10.5596 10.4678C10.4788 10.6839 10.3534 10.9172 10.1846 11.167L10.001 11.4219C9.74051 11.7665 9.38006 12.1865 8.91992 12.6807L7.17676 14.5449H10.8652V15.5537H5.66113V14.7471L5.67969 14.7256L8.32617 11.8291L8.75 11.3545C8.87706 11.208 8.9902 11.0725 9.08984 10.9482L9.22852 10.7646C9.3574 10.5839 9.45633 10.4129 9.52637 10.252L9.58887 10.0889C9.64233 9.92391 9.66892 9.75345 9.66895 9.57715C9.66895 9.30767 9.60418 9.07822 9.47754 8.88574V8.88477C9.35215 8.69054 9.17973 8.54025 8.95898 8.43359C8.73791 8.32681 8.48791 8.27246 8.20801 8.27246C7.98476 8.27249 7.78496 8.30757 7.60742 8.37598L7.4375 8.45508C7.22299 8.57343 7.05602 8.73879 6.9375 8.95312L6.93848 8.9541C6.82261 9.16858 6.7627 9.42244 6.7627 9.71777V9.79102H5.69238V9.71777C5.69239 9.23638 5.80287 8.81024 6.02734 8.44238C6.25089 8.07609 6.55591 7.79034 6.94043 7.58594H6.94141C7.3286 7.38167 7.76169 7.28032 8.23926 7.28027Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .147059
		})
	]
});
export default SvgIcon2D;
